import * as React from 'react';

import FormRow from '../../../../../components/FormRow';
import InputHandler from '../../../../../components/InputHandler';

const HeartRateForm = ({ formData }: IOwnProps): React.JSX.Element => (
  <React.Fragment>
    <FormRow title="general.date">
      <InputHandler
        type="PartialDate"
        editing={true}
        name="date"
        formData={formData}
        dateDefault="now"
        isNotCancellable={true}
      />
    </FormRow>
    <FormRow title="clinicalstudy.heartRate">
      <InputHandler
        type="NumberField"
        editing={true}
        name="heartRate"
        formData={formData}
        placeholder="clinicalstudy.heartRatePlaceholder"
      />
    </FormRow>
  </React.Fragment>
);

interface IOwnProps {
  formData: IFormData<IHeartRate>;
}

export default HeartRateForm;
